import React, { useState } from 'react'
import { FaPlay, FaPause } from 'react-icons/fa'
import { useVideoPlayer } from './hook/useVideoPlayer'

interface CustomVideoPlayerProps {
    videoSrc: string
}

const CustomVideoPlayer: React.FC<CustomVideoPlayerProps> = ({ videoSrc }) => {
    const { isPlaying, videoRef, togglePlay, handleVideoEnd } = useVideoPlayer()
    const [isButtonDisabled, setIsButtonDisabled] = useState(false)

    const handleTogglePlay = () => {
        setIsButtonDisabled(true)
        togglePlay()

        setTimeout(() => {
            setIsButtonDisabled(false)
        }, 300)
    }

    return (
        <div className="relative w-80 h-96 rounded-lg shadow-lg">
            <video
                ref={videoRef}
                src={videoSrc}
                className="w-full h-full rounded-lg"
                onClick={handleTogglePlay}
                onEnded={handleVideoEnd}
            />
            <button
                onClick={handleTogglePlay}
                disabled={isButtonDisabled}
                className={`absolute inset-0 m-auto text-white p-2 rounded-full shadow-lg bg-gray-800 bg-opacity-70 flex items-center justify-center transition-opacity duration-300 ${
                    isButtonDisabled ? 'opacity-50 cursor-not-allowed' : ''
                } ${isPlaying ? 'opacity-20' : 'opacity-100'}`}
                style={{ width: '60px', height: '60px' }}
            >
                {isPlaying ? <FaPause size={30} /> : <FaPlay size={30} />}
            </button>
        </div>
    )
}

export default CustomVideoPlayer
